import { render, staticRenderFns } from "./DogCard.vue?vue&type=template&id=32a503c8&scoped=true&"
import script from "./DogCard.vue?vue&type=script&lang=ts&"
export * from "./DogCard.vue?vue&type=script&lang=ts&"
import style0 from "./DogCard.vue?vue&type=style&index=0&id=32a503c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a503c8",
  null
  
)

export default component.exports